import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/hotels.vue'
wx.createPage(MiniProgramPage)